import { Skeleton } from 'antd';

/**
 * 与 OrderReturnDetailContent 布局一致的骨架屏：
 * OrderReturnInfo → OrderReturnReason → OrderReturnItems → CommentCard
 */
export const OrderReturnDetailContentSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      {/* OrderReturnInfo：1～2 个 DetailCard */}
      <div className="grid gap-4 grid-cols-2">
        <div className="bg-[#FFFFFF] rounded p-4 flex flex-col gap-3">
          <Skeleton.Input active size="small" className="!w-32 !min-w-0" />
          <div className="flex flex-col gap-2">
            <div className="flex justify-between gap-2">
              <Skeleton.Input active size="small" className="!w-20 !min-w-0" />
              <Skeleton.Input active size="small" className="!w-36 !min-w-0" />
            </div>
            <div className="flex justify-between gap-2">
              <Skeleton.Input active size="small" className="!w-20 !min-w-0" />
              <Skeleton.Input active size="small" className="!w-28 !min-w-0" />
            </div>
          </div>
        </div>
        <div className="bg-[#FFFFFF] rounded p-4 flex flex-col gap-3">
          <Skeleton.Input active size="small" className="!w-40 !min-w-0" />
          <Skeleton.Input active size="small" className="!w-full !min-w-0" />
        </div>
      </div>

      {/* OrderReturnReason */}
      <div className="bg-[#FFFFFF] rounded p-4 flex flex-col gap-3">
        <Skeleton.Input active size="small" className="!w-24 !min-w-0" />
        <div className="flex flex-col gap-2">
          <Skeleton.Input active size="small" className="!w-full !min-w-0" />
          <Skeleton.Input active size="small" className="!w-3/4 !min-w-0" />
        </div>
        <div className="flex gap-2 mt-1">
          <Skeleton.Avatar active shape="square" size={64} className="!rounded !w-16 !h-16" />
          <Skeleton.Avatar active shape="square" size={64} className="!rounded !w-16 !h-16" />
        </div>
      </div>

      {/* OrderReturnItems */}
      <div className="bg-[#FFFFFF] rounded p-4 flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <Skeleton.Input active size="small" className="!w-24 !min-w-0" />
          <Skeleton.Input active size="small" className="!w-32 !min-w-0" />
        </div>
        <div className="flex flex-col gap-3">
          {[1, 2].map((i) => (
            <div key={i} className="flex gap-3 items-start">
              <Skeleton.Avatar
                active
                shape="square"
                size={48}
                className="!rounded-[2px] !w-12 !h-12 flex-shrink-0"
              />
              <div className="flex-1 min-w-0 space-y-2">
                <Skeleton.Input active size="small" className="!w-full !min-w-0" />
                <div className="flex gap-2">
                  <Skeleton.Input active size="small" className="!w-16 !min-w-0" />
                  <Skeleton.Input active size="small" className="!w-20 !min-w-0" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CommentCard */}
      <div className="bg-[#FFFFFF] rounded p-4 flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <Skeleton.Input active size="small" className="!w-20 !min-w-0" />
          <Skeleton.Button active size="small" className="!min-w-0" />
        </div>
        <Skeleton.Input active size="small" className="!w-full !min-w-0" />
      </div>
    </div>
  );
};
